export const formatBrlInput = (value) => {
  const digits = String(value ?? '').replace(/\D/g, '');
  const cents = digits ? Number(digits) : 0;
  return (cents / 100)
    .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    .replace(/\u00a0/g, ' ');
};

export const parseBrlInputToCents = (value) => {
  const digits = String(value ?? '').replace(/\D/g, '');
  return digits ? Number(digits) : 0;
};

export const initialInvoiceHistoryFilters = () => ({
  companyId: '',
  reference: '',
  paymentStatus: 'Pendente',
  emissionFrom: '',
  emissionTo: '',
  dueFrom: '',
  dueTo: '',
});
